import styled from 'styled-components';

const SubLabel = styled.div`
    color: ${props => props.theme.colors.subtle.regular};
`;

export default SubLabel;
